<template>
  <div class="card mb-4 shadow-sm border border-light">
    <div class="card-body pt-3 px-3 pb-2">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <titles text="Debitor borclar" style="margin: 0;" />
        <span class="top-info">Top 50</span>
      </div>
      <hr class="my-2" />
      <div style="max-height: 325px; overflow-y: auto; padding-right: 6px;">
        <div v-for="(item, idx) in topDebtors" :key="idx" class="custom-warning-box border border-light mb-2 px-3 py-2">
          <div class="d-flex justify-content-between align-items-start">
            <div class="text-part">
              <div class="subrogation">
                <a href="javascript:void(0)" class="id" @click="openSubrogation(item.subrogationId)">
                  Subroqasiya işi №{{ item.subrogationNumber }}
                </a>
              </div>
              <div class="desc">{{ item.defendant || '-' }}</div>
            </div>
            <div class="amount-part text-end">
              <div class="amount">
                {{ formatAmount(item.debt) }} AZN
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Titles from "@/project/Components/Titles.vue";
import { GetDebtJournal } from "@/project/Source/journals.js";

export default {
  name: "TopDebtors",
  components: { Titles },
  data() {
    return {
      allDebtors: [],
    };
  },
  computed: {
    topDebtors() {
      return this.allDebtors.slice(0, 50);
    },
  },
  mounted() {
    this.loadDebtors();
  },
  methods: {
    async loadDebtors() {
      try {
        const params = {
          page: 1,
          pageSize: 50,
          searchText: ""
        };
        const res = await GetDebtJournal(params);
        this.allDebtors = res?.data.data || [];
      } catch (e) {
        console.error("GetDebtJournal error", e);
      }
    },
    openSubrogation(id) {
      const route = this.$router.resolve({
        name: "Subroqasiya - Məlumat",
        params: { id }
      });
      window.open(route.href, "_blank");
    },
    formatAmount(val) {
      if (val == null) return '-';
      return Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>

<style scoped>
.custom-warning-box {
  border-left: 2px solid #eab308;
  background-color: #fff;
  border-radius: 6px;
  transition: box-shadow 0.15s ease;
  font-size: 11px;
  line-height: 1.4;
  padding: 6px 10px !important;
}

.custom-warning-box:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.subrogation {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 1px;
}

.subrogation .id {
  color: #004eb3 !important;
  text-decoration: underline;
  font-weight: 600;
}

.desc {
  font-size: 11px;
  color: #374151;
}

.amount {
  font-weight: bold;
  font-size: 12px;
  color: #111827;
}

.text-part {
  max-width: calc(100% - 120px);
}

.amount-part {
  min-width: 100px;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: transparent;
}
</style>
